import { render, staticRenderFns } from "./ViPaymentCompletd.vue?vue&type=template&id=2b7ed30f&scoped=true"
import script from "./ViPaymentCompletd.vue?vue&type=script&lang=js"
export * from "./ViPaymentCompletd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7ed30f",
  null
  
)

export default component.exports